export default __webpack_public_path__ + "static/media/cri_genetics_logo.b719b6ed.svg";